import { Injectable } from '@angular/core';

import {
  UserGeographicAreaV1Model,
  buildGeographicAreas
} from '@core/models/entities/implementations/user-geographic-area-v1';
import { MapBackdropService } from '@core/services/map-backdrop/map-backdrop.service';

import { GaliaArea } from '@features/components/visualization/mapbox/models/galia-area';

/**
 * The geographic zones drawn underneath sites and routes. Zones are built through the same
 * `buildGeographicAreas` the zone entity registers for its own visualization, so a zone
 * looks and behaves identically whether it is the subject of the map or context on it.
 */
@Injectable({ providedIn: 'root' })
export class AreaContextService extends MapBackdropService<
  UserGeographicAreaV1Model,
  GaliaArea
> {
  protected readonly entityType = 'GEOGRAPHIC_AREA';
  protected readonly entityName = 'geographic_area';

  protected build(rows: UserGeographicAreaV1Model[]): GaliaArea[] {
    return rows.flatMap((row) => buildGeographicAreas(row));
  }
}
